import { createAction, props } from '@ngrx/store';
import { SelectedTreeItem, TreeAndItems } from './object-tree.models';

export const SetTreeItemsLoading = createAction(
  '[Object Tree] Set Tree Items Loading'
)

export const SetTreeItems = createAction(
  '[Object Tree] Set Tree Items',
  props<{ items: TreeAndItems }>()
)

export const ClearTreeItems = createAction(
  '[Object Tree] Clear Tree Items'
)

export const SetSelectedItems = createAction(
  '[Object Tree] Set Selected Items',
  props<{ items: SelectedTreeItem[] }>()
)

export const SetSelectedItemIds = createAction(
  '[Object Tree] Set Selected ItemIds',
  props<{ items: number[] }>()
)

export const SelectTreeItem = createAction(
  '[Object Tree] Select TreeItem',
  props<{ itemId: number }>()
)


export const SetTreeErrors = createAction(
  '[Object Tree] Set Tree Errors',
  props<{ errors: { [key: string]: any } | null }>()
)
